import React from 'react';
import ClassSelectPage from './ClassSelectPage';

const ClassCadreSelectPage = () => {
  return <ClassSelectPage type="cadres" />;
};

export default ClassCadreSelectPage;
